import { createSelector } from 'reselect';

const selectProjects = (state: any) => state.projects;


export const selectProjectsCurrentItem = createSelector([selectProjects], (projects) => projects.current);

export const selectProjectsListItems = createSelector([selectProjects], (projects) => projects.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectProjectsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProjectsQueryItems = createSelector([selectProjects], (projects) => projects.query);

export const selectProjectsCreatedItem = createSelector([selectProjects], (projects) => projects.create);

export const selectProjectsUpdatedItem = createSelector([selectProjects], (projects) => projects.update);

export const selectProjectsReadItem = createSelector([selectProjects], (projects) => projects.read);

export const selectProjectsDeletedItem = createSelector([selectProjects], (projects) => projects.delete);

export const selectProjectsSearchedItems = createSelector([selectProjects], (projects) => projects.search);

export const selectProjectsItemsCount = createSelector([selectProjects], (projects) => projects.count);

export const selectProjectsItemsFilter = createSelector([selectProjects], (projects) => projects.filter);

export const selectProjectsSummaryItems = createSelector([selectProjects], (projects) => projects.summary);